import { Button } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

import { baseLinkCss } from './styled';
import { HoverTheme, IHover } from './types';

export const AddNewCardLink = Button.withConfig<IHover>(p => ({
  _text: {
    textAlign: 'left',
    color: p.hoverTheme === HoverTheme.DARK ? primitive.$mayoEggWhite : '#000',
    fontSize: 'sm',
    fontFamily: 'body',
  },

  padding: 0,
  paddingLeft: '$3',

  _hover: {
    backgroundColor: primitive.$fieryRed,
    color: p.hoverTheme === HoverTheme.DARK ? 'inherit' : primitive.$mayoEggWhite,
  },

  ...baseLinkCss,
}));
